import style from "./IndividualCourseCard.module.css";
import Icon from "@/ui/icon/Icon";
import Button from "@/ui/button/Button";
import { Link } from "react-router-dom";
import { padZero, secondsToHoursMinutes } from "@/utils/helpers";
import { useGetCourse } from "../../hooks/useGetCourse";
import CourseCategory from "../courseCategory/CourseCategory";

function IndividualCourseCard({ course, color = "", reverse = false }) {
	const {
		name: courseName,
		slug: courseSlug,
		like_count: likeCount,
		module_count: moduleCount,
		thumbnail: courseThumbnail,
		duration,
	} = course;

	const { data, isPending } = useGetCourse({
		courseSlug: courseSlug,
	});

	if (isPending) return <></>;

	const { course: courseInfo } = data;
	const { description, lecturers } = courseInfo;

	// Strip HTML tags from description
	const stripHtmlTags = (html) => {
		const div = document.createElement("div");
		div.innerHTML = html;
		return div.textContent || div.innerText || "";
	};

	const plainDescription = stripHtmlTags(description);

	return (
		<section className={`${style.continue} ${reverse && style.reverse}`}>
			<div className={style.body}>
				<div
					className={style.continueCourse}
					style={{ "--background": color }}
				>
					<Link
						to={`/courses/${courseSlug}`}
						className={style.thumbnailHolder}
					>
						<div
							className={style.thumbnail}
							style={{
								"--image": `url(${courseThumbnail})`,
							}}
						>
							<CourseCategory
								course={course}
								className={style.category}
							/>
						</div>
					</Link>
					<div className={style.info}>
						<h3>{courseName}</h3>
						<div className={style.labels}>
							<div className={style.otherInfo}>
								<div>
									<Icon icon="fa-heart" />
									<span>{padZero(likeCount)}</span>
								</div>
								<span className={style.sep}></span>
								<div>
									<Icon icon="fa-layer-group" />
									<span>{padZero(moduleCount)}</span>
								</div>
								<span className={style.sep}></span>
								<div>
									<Icon icon="fa-timer" />
									<span>
										{secondsToHoursMinutes(duration)}
									</span>
								</div>
							</div>
						</div>
						<div className={style.description}>
							<p>
								{plainDescription.length > 250
									? plainDescription.slice(0, 250) + "..."
									: plainDescription}
							</p>
						</div>

						<div className={style.footer}>
							<div className={style.lecturer}>
								<div className={style.imgHolder}>
									<img
										src={lecturers[0].picture_url}
										alt={lecturers[0].name}
									/>
								</div>
								<div className={style.lecturerInfo}>
									<span className={style.name}>
										{lecturers[0].name}
									</span>
									<span className={style.jobTitle}>
										{lecturers[0].job_title}
									</span>
								</div>
							</div>
							<Button to={`/courses/${courseSlug}`} type="accent">
								<span>Započni</span>
								<Icon icon="fa-play" />
							</Button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default IndividualCourseCard;
